<script>
import BaseAutocomplete from '@/components/elements/Base/BaseAutocomplete';
import AuctionService from '@/services/auction-service.js';

export default {
	extends: BaseAutocomplete,
	name: 'autocomplete-auction',
	methods: {
		itemHasChanged(auction) {
			this.$emit('update:auction', auction);
		},
		request() {
			return AuctionService.getAll;
		},
		customLabel(auction) {
			return auction.title;
		},
		setSelection() {
			this.getAutocomplete(this.request, '');
			this.currentSelection = this.selected;
		}
	}
}
</script>



// WEBPACK FOOTER //
// AutocompleteAuction.vue?40e5a62f